export class Validator {
    init()
    {
        if( typeof contactFormRules !== 'object' ){
            return;
        }

        var $_FORM = $('#contactForm'),
            submitHandler = function(form, event) {
                event.preventDefault();

                if( typeof grecaptcha === 'object' )
                {
                    grecaptcha.execute( $('[data-rekey]').data('rekey'), {action: 'contactForm'} ).then(function(response) {
                        return ajaxCall({g_response: response, g_action: 'contactForm'});
                    });
                }
                else
                {
                    return ajaxCall();
                }

            },
            ajaxCall = function(appendData) {
                return $.ajax({
                            url: $_FORM.attr("action"),
                            method: 'POST',
                            data: ajaxData(appendData),
                            beforeSend: ajaxBeforeSend,
                            success: ajaxSuccess,
                            error: ajaxError
                        });
            },
            ajaxData = function(appendData) {
                var serialized = $_FORM.serialize();

                if( typeof appendData !== 'object' )
                {
                    return serialized;
                }

                $.each(appendData, function(key, value) {
                    serialized += '&' + key + '=' + value;
                });

                return serialized;
            },
            ajaxBeforeSend = function() {
                $_FORM.find('button').prop('disabled', 'disabled');
            },
            ajaxSuccess = function() {
                // callFbq();

                $_FORM.find('input, textarea').val('');
                $_FORM.fadeOut(500, function () {
                    $_FORM.replaceWith('<p class="form__message form__message--success">Message was sent. Thank you .</p>').fadeIn(500);
                });
            },
            ajaxError = function() {
                $_FORM.find('input, textarea').val('');
                $_FORM.fadeOut(500, function ()
                {
                    $_FORM.replaceWith('<p class="form__message form__message--error">The message was not sent. Please try again later.</p>').fadeIn(500);
                });
            },
            callFbq = function() {
                if( typeof fbq === 'function' )
                {
                    fbq('track', 'Lead');
                }
            };

        $_FORM.validate({
            rules: contactFormRules,
            messages:{
                name: {
                    required: 'this field is required'
                },
                email: {
                    required: 'this field is required',
                    email: 'please make sure the email address is correct'
                },
                message: {
                    required: 'this field is required'                    
                }
            },
            errorPlacement: function(error, element) {
                error.insertAfter(element);
            },
            submitHandler: submitHandler
        });
    }
}